<template>
    <section>
        <Sidebar />
        <Content class="create-test-case-page">
            <template v-if="user_plan && plan_limitations && user_plan.plan > 0 && user_plan.testcases <= plan_limitations.testcases">
                <h1><i class="fas fa-flask" style="margin-right: 5px;"></i> New test case</h1>
                <div class="row first-row">
                    <div class="col-sm-2 first-column">
                        <b-select placeholder="GET" style="width:100%" v-model="endpoint.method" required>
                            <option value="0" key="get" selected>GET</option>
                            <option value="1" key="post">POST</option>
                            <option value="2" key="put">PUT</option>
                            <option value="3" key="patch">PATCH</option>
                            <option value="4" key="delete">DELETE</option>
                            <option value="5" key="copy">COPY</option>
                            <option value="6" key="head">HEAD</option>
                            <option value="7" key="options">OPTIONS</option>
                            <option value="8" key="link">LINK</option>
                            <option value="9" key="unlink">UNLINK</option>
                            <option value="10" key="purge">PURGE</option>
                            <option value="11" key="lock">LOCK</option>
                            <option value="12" key="unlock">UNLOCK</option>
                            <option value="13" key="propfind">PROPFIND</option>
                            <option value="14" key="view">VIEW</option>
                        </b-select>
                    </div>
                    <div class="col-sm-10 second-column">
                        <b-input type="url" ref="url" placeholder="URL" style="width:100%" v-model="endpoint.url" required></b-input>
                    </div>
                </div>
                <div class="second-row">
                    <section style="background: white; font-size: 14px;">
                        <b-tabs v-model="activeTab">
                            <b-tab-item label="Params">
                                <div class="row" v-for="(param, index) in params" :key="'param-' + index" style="position: relative; margin-bottom: 10px;">
                                    <div class="col-xs-6">
                                        <b-input type="text" placeholder="Key" data-hj-masked v-model="param.key" @input="onChangeParams"></b-input>
                                    </div>
                                    <div class="col-xs-6" style="padding-left: 0px; padding-right: 40px;">
                                        <b-input type="text" placeholder="Value" data-hj-masked v-model="param.value" @input="onChangeParams"></b-input>
                                    </div>
                                    <b-button type="is-danger" @click="removeFromParams(index)" style="position: absolute; top: 7px; right: 9px; font-size: 9px;">
                                        <i class="fas fa-times"></i>
                                    </b-button>
                                </div>
                            </b-tab-item>

                            <b-tab-item label="Headers">
                                <div class="row" v-for="(header, index) in headers" :key="'header-' + index" style="position: relative; margin-bottom: 10px;">
                                    <div class="col-xs-6">
                                        <b-input type="text" data-hj-masked placeholder="Key" v-model="header.key" @input="onChangeHeaders"></b-input>
                                    </div>
                                    <div class="col-xs-6" style="padding-left: 0px; padding-right: 40px;">
                                        <b-input type="text" data-hj-masked placeholder="Value" v-model="header.value" @input="onChangeHeaders"></b-input>
                                    </div>
                                    <b-button type="is-danger" @click="removeFromHeaders(index)" style="position: absolute; top: 7px; right: 9px; font-size: 9px;">
                                        <i class="fas fa-times"></i>
                                    </b-button>
                                </div>
                            </b-tab-item>

                            <template v-if="endpoint.method != '0'">
                                <b-tab-item label="Body (json)" v-if="jsonOptions">
                                    <VJsoneditor 
                                        v-model="endpoint.body" 
                                        :options="jsonOptions" 
                                        :plus="false" 
                                        height="150px" 
                                        @error="onError"
                                        @validate="onValidate" />
                                </b-tab-item>
                            </template>

                            <b-tab-item label="Timeout">
                                <b-field label="Milliseconds">
                                    <b-numberinput v-model="timeout" step="250" min="250" max="15000" ref="timeout"></b-numberinput>
                                </b-field>
                            </b-tab-item>

                        </b-tabs>
                    </section>
                </div>

                <p style="text-align: center; padding-top: 15px; font-size: 22px;"><i class="fas fa-chevron-down"></i></p>

                <div class="asserts-container">
                    <h2 style="margin-bottom: 10px;"><i class="fab fa-buffer"></i> Asserts</h2>
                    <div class="col-xs-5">
                        <b-input type="text" value="response.status_code" disabled></b-input>
                    </div>
                    <div class="col-xs-2" style="padding: 0px;">
                        <b-select placeholder="=" style="width:100%" v-model="endpoint.expected_operation">
                            <option value="0" key="=" selected>=</option>
                            <option value="1" key="!=" selected>!=</option>
                        </b-select>
                    </div>
                    <div class="col-xs-5" style="padding-right: 40px;">
                        <b-input type="text" v-model="endpoint.expected_status_code"></b-input>
                    </div>
                        <!--<b-button type="is-danger" @click="removeFromParams(index)" style="position: absolute; top: 7px; right: 9px; font-size: 9px;">
                            <i class="fas fa-times"></i>
                        </b-button>-->
                </div>

                <b-button @click="saveTestCase()" type="is-primary" style="width:150px; display: block; margin: 55px auto 20px auto">
                    Save test case
                </b-button>
            </template>
            <template v-else-if="plan_limitations && user_plan">
                <b-notification type="is-warning" v-if="user_plan.testcases >= plan_limitations.testcases">
                    <i class="fas fa-exclamation-triangle" style="margin-right: 5px;"></i> You have reached maximum allowed number of Test Cases
                </b-notification>
                <b-notification type="is-info" v-else-if="!user_plan || user_plan.plan == 0">
                    <i class="fas fa-exclamation-triangle" style="margin-right: 5px;"></i> You have not subscribed yet. Choose a plan and start using Devect
                </b-notification>
                <Plans />
            </template>
        </Content>
    </section>
</template>

<script>
import Sidebar from "../components/sidebar/Sidebar"
import Content from "../components/Content"
import {getEndpoint, createEndpoint} from "../logic/endpoints"
import {createTestCase} from "../logic/testcase"
import {getJWTContent, getUserPlan} from "../logic/global"
import VJsoneditor from 'v-jsoneditor/src/index'
import constants from '../constants'
import Plans from '../components/Plans'


let endpoint = {
    "url": "",
    "method": "0",
    "body": "",
    "expected_status_code": 200,
    "expected_operation": 0,
    "expected_time": null
}

let params = [
    {"key": "", "value": ""}
]

let headers = [
    {"key": "", "value": ""}
]

export default {
    name: 'APITestCaseCreate',
    components: {Sidebar, Content, VJsoneditor, Plans},
    data() {
        return {
            timeout: 10000,
            endpoint: endpoint,
            params: params,
            headers: headers,
            user_plan: null,
            plan_limitations: null,
            activeTab: 1,
            json: {
                "hello": "world"
            },
            jsonOptions: {
                "mode": "code",
                "mainMenuBar": false,
                "navigationBar": false,
            }
        }
    },
    methods: {
        goToNextStep: function(){
            getEndpoint(this.$route.params.test_id).then(response => {
                console.log(response.data)
            })
        },
        onChangeParams: function(){
            if(this.params[this.params.length - 1].key != ""){
                this.params.push({"key": "", "value": ""})
            }
        },
        onChangeHeaders: function(){
            if(this.headers[this.headers.length - 1].key != ""){
                this.headers.push({"key": "", "value": ""})
            }
        },
        removeFromParams: function(index){
            if(this.params.length > 1){
                this.params.splice(index, 1)
            }
        },
        removeFromHeaders: function(index){
            if(this.headers.length > 1){
                this.headers.splice(index, 1)
            }
        },
        onError() {},
        onValidate: function (json) {
            var errors = [];

            if (json && json.customer && !json.customer.address) {
                errors.push({
                    path: ['customer'],
                    message: 'Required property "address" missing.'
                });
            }
            console.log(errors)
            return errors;
        },
        showSuccessMsg: function(message, msg_type){
            this.$buefy.toast.open({message: message, type: msg_type})
        },
        removeUnusedParamsAndHeaders: function(){
            for(let i = 0; i<this.params.length; i++){
                if(this.params[i]["key"] == "" || this.params[i]["value"] == ""){
                    this.params.splice(i,1);
                }
            }
            for(let i = 0; i<this.headers.length; i++){
                if(this.headers[i]["key"] == "" || this.headers[i]["value"] == ""){
                    this.headers.splice(i,1);
                }
            }
        },
        saveTestCase: function(){
            this.removeUnusedParamsAndHeaders()

            let _this = this
            let isUrlValid = this.$refs.url.checkHtml5Validity()
            let isTimeoutValid = this.$refs.timeout.checkHtml5Validity()

            if(isUrlValid && isTimeoutValid){
                let payload = {...this.endpoint}
                payload["params"] = this.params;
                payload["headers"] = this.headers;
                payload["timeout"] = this.timeout;
                
                createTestCase(this.$route.params.test_id, payload).then(response => {
                    _this.showSuccessMsg("Test Case created successfully", "is-success")
                    _this.$router.push({name: 'api-test-single', params: {'test_id': this.$route.params.test_id}})
                    window.location.reload()
                }).catch(error => {
                    if(error.response && error.response.status == 400){
                        _this.showSuccessMsg("Error: Make sure all the information is correct", "is-danger")
                    }else{
                        _this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
                    }
                });
            }else{
                if(!isUrlValid){
                    _this.showSuccessMsg("The URL is not valid", "is-danger")
                }
                if(!isTimeoutValid){
                    _this.showSuccessMsg("The timeout must be between 250 and 15000", "is-danger")
                }
            }
        }
    },
    mounted: function(){
        getUserPlan().then(response => {
            this.user_plan = response.data
            this.plan_limitations = constants.PLANS_LIMITATIONS[this.user_plan.plan]
        })
    }
}
</script>

<style scoped>
    h1{margin-bottom: 24px;}
    .first-row .first-column{padding-right: 0px; margin-right: -1px;}
    .first-row .second-column{padding-left: 0px;}
    .first-row .third-column{padding-left: 0px}
    .first-row >>> b-select .select, .first-row >>> select, .first-row >>> .select, .first-row >>> b-input{width: 100%}
    .asserts-container >>> b-select .select, .asserts-container >>> select, .asserts-container >>> .select, .asserts-container >>> b-input{width: 100%}

    .asserts-container >>> b-select .select,
    .asserts-container >>> select,
    .asserts-container >>> .select,
    .asserts-container >>> .select select{
        text-align: center !important;
        text-align-last:center;
    }

    .create-test-case-page >>> .select select{
        border-radius: 0px;
        padding-left: 10px;
        font-size: 13px;
        height: 36px;
    }

    .create-test-case-page >>> .has-numberinput label{
        font-weight: 400;
        font-size: 14px;
    }

    .third-column i{margin-left: 2px; font-size: 9px; vertical-align: middle}

    .create-test-case-page >>> .button{border-radius: 0px;}
    .create-test-case-page >>> .input{border-radius: 0px;}
    .create-test-case-page >>> .select select{border-radius: 0px;}
    .create-test-case-page >>> select{border-radius: 0px;}

    .second-row >>> .tabs a{
        font-size: 14px;
        text-decoration: none;
    }
    .second-row >>> .b-tabs .tabs {
        margin-bottom: 0;
        flex-shrink: 0;
        border-left: 1px solid #dbdbdb;
        border-right: 1px solid #dbdbdb;
    }

    /*.second-row >>> .ace_gutter-cell.ace_error{background-image: none !important;}*/
    .second-row >>> .ace-jsoneditor .ace_constant.ace_numeric{color: gray}
    .second-row >>> div.jsoneditor{border: 0px;}

    .asserts-container{
        margin-top: 40px;
    }
</style>